var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMongodb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#28654B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6063 7.23481C19.3465 5.79517 18.2611 4.32282 18.0406 4.02068C18.0361 4.0143 18.03 4.00909 18.0229 4.00548C18.0158 4.00188 18.0079 4 17.9999 4C17.9918 4 17.9839 4.00188 17.9768 4.00549C17.9697 4.00909 17.9636 4.01431 17.9591 4.02069C17.7387 4.32283 16.6535 5.79517 15.3937 7.23481C4.59611 20.5556 17.098 29.543 17.098 29.543L17.1993 29.6112C17.2941 31.0017 17.5296 33 17.5296 33H18.4704C18.4704 33 18.7049 31.0103 18.8001 29.6202L18.9021 29.543C18.9021 29.543 31.4038 20.5556 20.6063 7.23481ZM18 29.3477C18 29.3477 17.1526 28.7569 17.0014 28.525L17 28.5L17.9648 14.1253C17.9652 14.1165 17.9691 14.1082 17.9756 14.1021C17.9822 14.096 17.9909 14.0927 18 14.0927C18.0091 14.0927 18.0178 14.096 18.0244 14.1021C18.0309 14.1082 18.0348 14.1165 18.0352 14.1253L19 28.5L18.9987 28.5249C18.8475 28.7568 18 29.3477 18 29.3477Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMongodb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mongodb.607240168fc102556660e4a360fca78c.svg";